export const SnackbarType = {
  Negative: { variant: "alert", alert: { color: "error", variant: "filled" } },
  Success: { variant: "alert", alert: { color: "success" } },
  Info: { variant: "alert", alert: { color: "primary" } },
  Warning: { variant: "alert", alert: { color: "warning", variant: "filled" } },
  Yellow: { variant: "alert", alert: { color: "yellow", variant: "filled" } },
};
